import { useMutation } from '@tanstack/react-query'
import { createCheckoutSession, createPortalSession } from './billingApi'

/**
 * Custom hook for billing operations (checkout and portal access).
 *
 * @returns {Object} Billing mutations and loading states
 */
export const useBilling = () => {
    const { mutate: createCheckout, isPending: isCreatingCheckout } = useMutation({
        mutationFn: ({ tier, accountID }) => createCheckoutSession(tier, accountID),
    })

    const { mutate: createPortal, isPending: isCreatingPortal } = useMutation({
        mutationFn: ({ accountID }) => createPortalSession(accountID),
    })

    return {
        createCheckout,
        isCreatingCheckout,
        createPortal,
        isCreatingPortal,
    }
}
